/**
 * Cleans up a Google Map instance by removing all event listeners and removing the onSpotHover listener from the document.
 *
 * @param {object} options - The options for the map cleanup.
 * @param {object} options.map - The Google Map instance to be cleaned up.
 * @param {object} options.maps - The Google Maps API object.
 */
export const cleanupMap = ({ map, maps, }) => {
    maps.event.clearInstanceListeners(map);
};
